import type { ReactNode } from 'react';

export type Tone = 'gate' | 'go' | 'stop' | 'signal' | 'wire' | 'ink';

export function StampBadge({
  tone = 'ink',
  pulse,
  children,
}: {
  tone?: Tone;
  pulse?: boolean;
  children: ReactNode;
}) {
  return (
    <span className="fl-stamp" data-tone={tone} data-pulse={pulse || undefined}>
      {children}
    </span>
  );
}

/** Content produced by an agent is labelled; human-authored content carries nothing. */
export function AgentTag({ token }: { token: string }) {
  return (
    <span className="fl-stamp" data-tone="signal">
      Agent · {token}
    </span>
  );
}

export function Chip({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <span className="fl-chip" title={title}>
      {children}
    </span>
  );
}
